import jwtDecode from "jwt-decode";
import router from "@/router";
import { initState } from "./index";
import refreshToken from "@/services/refreshToken";
import getSPUser from "@/services/getSPUser";

const AUTH_TOKEN = process.env.VUE_APP_AUTH_TOKEN_NAME;
const SP_HOST = process.env.VUE_APP_SP_HOST;

const { VUE_APP_SP_HOST, VUE_APP_SP_SITE_URL, NODE_ENV } = process.env;

const URL_LOGIN_APP = `https://${VUE_APP_SP_HOST}/${VUE_APP_SP_SITE_URL}/login`;
let msTokenTimeOutId = null;
let ictTokenTimeOutId = null;
let msTokenCheckTimeIntervalId = null;

export default {
  login: ({ commit, dispatch }, payload) => {
    localStorage.setItem(AUTH_TOKEN, payload);
    const jwtExpDecode = jwtDecode(payload);
    dispatch("initMsToken", payload);
    commit("setAuth", jwtExpDecode);
    dispatch("checkTimeout", jwtExpDecode.exp);
    // so sánh user với SP
    if (SP_HOST && NODE_ENV && NODE_ENV === "production") {
      dispatch("checkCurrentUserEmailEqualSPUser", jwtExpDecode);
    }
  },
  logout: ({ commit }) => {
    localStorage.removeItem(AUTH_TOKEN);
    commit("setAuth", initState);
    window.location.replace(
      `https://${VUE_APP_SP_HOST}/${VUE_APP_SP_SITE_URL}/login/logout.html?full=true`
    );
  },
  // Payload: timeout
  checkTimeout: ({ dispatch }, payload) => {
    if (ictTokenTimeOutId) {
      clearTimeout(ictTokenTimeOutId);
    }
    const now = new Date();
    const expirationDate = new Date(payload * 1000);
    const expirationTime = expirationDate.getTime() - now.getTime();
    // if (expirationTime <= 0) {
    //   router.push("/auth/login");
    //   return;
    // }
    ictTokenTimeOutId = setTimeout(() => {
      dispatch("logout");
    }, expirationTime);
  },
  init: ({ dispatch, state }) => {
    const token = localStorage.getItem(AUTH_TOKEN) || state?.token;
    if (token) {
      dispatch("login", token);
    } else {
      // dispatch("logout");
      router.push("/auth/login");
      window.location.replace(`${URL_LOGIN_APP}/?to=${window.location.href}`);
    }
  },
  /**
   * MS TOKEN
   */
  repeatCheckMsToken: ({ dispatch, state }) => {
    // let msTokenCheckTimeIntervalId = null;
    // let lastTimeRequestToken = undefined;
    // check token gần hết hạn
    if (state.msToken) {
      const jwtExpDecode = jwtDecode(state.msToken);

      const now = new Date();
      const ngayHetHan = new Date(jwtExpDecode.exp * 1000);
      const timeLeft = ngayHetHan.getTime() - now.getTime();

      const isOverTenMinute = timeLeft / 1000 / 60 <= 15;
      if (isOverTenMinute) {
        dispatch("initMsToken", localStorage.getItem(AUTH_TOKEN));
      }
    }
  },
  initMsToken: async ({ dispatch, commit }, payload) => {
    if (payload) {
      try {
        // Send a POST request
        const { data } = await refreshToken(payload);
        if (data?.refreshMsToken) {
          // set msToken
          commit("setMsToken", data.refreshMsToken);

          if (!msTokenCheckTimeIntervalId) {
            msTokenCheckTimeIntervalId = setInterval(() => {
              dispatch("repeatCheckMsToken");
            }, 5 * 60 * 1000); // call at 5 minus
          }
        } else {
          console.log("> Lỗi get new refreshToken");
          // dispatch("logout");
        }
      } catch (error) {
        console.log("> Lỗi refreshToken", error);
      }
    } else {
      // dispatch("logout");
      router.push("/auth/login");
    }
  },
  // Kiểm tra nếu user SP !== user Graph thì logout
  checkCurrentUserEmailEqualSPUser: async ({ dispatch }, payload) => {
    try {
      const { data } = await getSPUser();
      if (data?.d?.Email) {
        if (data.d.Email !== payload.email?.toString()) {
          console.log("diff email", data.d.Email, payload.email?.toString());
          // localStorage.removeItem(AUTH_TOKEN);
          // window.location.replace(
          //   `${URL_LOGIN_APP}/?to=${window.location.href}`
          // );
        }
      }
    } catch (error) {
      console.log("Error checkCurrentUserEmailEqualSPUser: ", error);
    }
  },
};
